export const validateFields = (employee, t) => {
  const requiredFields = {
    name: t("form.employee.name"),
    wkl_wrk_load: t("form.employee.weeklyWorkload"),
    day_WI: t("form.employee.dailyWorkload"),
    number: t("form.employee.number"),
    team: t("form.employee.team")
  };

  for(const[field,label] of Object.entries(requiredFields)){
    if(field === 'name'){
      if(!employee[field] || typeof employee[field] !== 'string' || !employee[field].trim()){
        return {
          isValid: false,
          error: {
            title: t("alert.validation.error"),
            description: `${t("alert.error.fillIn")} ${label}`,
            variant: 'destructive'
          }
        };
      }
      continue;
    }

    const value = employee[field];
    if(value === undefined || value === '' || value === null) {
      return {
        isValid: false,
        error: {
          title: t("alert.validation.error"),
          description: `${t("alert.error.fillIn")} ${label}`,
          variant: 'destructive'
        }
      };
    }

    const numValue = Number(value);
    if(isNaN(numValue) || numValue < 0){
      return {
        isValid: false,
        error: {
          title: t("alert.validation.error"),
          description: `${t("alert.error.validNumber")} ${label}`,
          variant: 'destructive'
        }
      };
    }
  }

  return {
    isValid: true,
    error: null
  };
};

export const exampleTeam = {
  id: 'example-team',
  name: 'Example Team',
  employees: [
    {
      name: "John Smith",
      number: 101,
      wkl_Wrk_Load: 400,  
      day_WI: 80,         
      at_Roster_Num: 1
    },
    {
      name: "Sarah Johnson",
      number: 102,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Anna Brown",
      number: 103,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Dwyane Wade",
      number: 104,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Michael Porter",
      number: 105,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Kobe James",
      number: 106,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Larry Bird",
      number: 107,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Marvin Williams",
      number: 108,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Derrick Rose",
      number: 109,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    },
    {
      name: "Thomas Jones",
      number: 110,
      wkl_Wrk_Load: 400,
      day_WI: 80,
      at_Roster_Num: 1
    }
  ]
};